import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Itenrary.css";

function Itineraries() {
  const [itineraries, setItineraries] = useState([]);
  const navigate = useNavigate();



  useEffect(() => {
    axios
      .get("https://ttfadmin.onrender.com/api/itineraries")
      .then((res) => setItineraries(res.data))
      .catch((err) => console.error(err));
  }, []);

  const openDetail = (id) => {
    navigate(`/package/${id}`);
  };

  return (
    <div className="itineraries">
      <h2>Available Trips</h2>
      <div className="itinerary-grid">
        {itineraries.map((trip) => (
          <div key={trip._id} className="itinerary-card" role="button" tabIndex={0} onKeyPress={(e) => { if (e.key === 'Enter') openDetail(trip._id); }}>
            <div className="media" onClick={() => openDetail(trip._id)}>
              <img src={trip.coverImage || trip.images?.[0]} alt={trip.title} />
              <div className="quick">
                <button aria-label="Quick view" onClick={(e)=>{ e.stopPropagation(); openDetail(trip._id); }}>🔍</button>
              </div>
            </div>
            <div className="card-body" onClick={() => openDetail(trip._id)}>
              <h3>{trip.title}</h3>
              <p className="truncated">{trip.shortDescription}</p>

              <div className="meta">
                <div className="badge">{trip.duration?.nights}N / {trip.duration?.days}D</div>
                <div className="locations">{trip.locations?.slice(0,3).join(", ")}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Itineraries;
